import {MemoStateType} from 'module/Memo/reducer/MemoReducer'

export const selMemoMap = (state: MemoStateType) => state.Memo